// O bundle do design system é um script clássico que lê `window.React`.
// Este módulo precisa ser importado ANTES de vendor/bundle.js (ver index.ts).
import * as React from 'react';

const g = globalThis as unknown as { React?: typeof React };
if (!g.React) g.React = React;
